<template>
<div class="container main">
    <div class="row">
        <div class="offset-10 col-2 head-buttons-block">
        <router-link :to="{ name: 'auth'}" class="login-btn">
            <div class="enter-logo"></div><span>Войти</span>
        </router-link>
        </div>
    </div>
  </div>
</template>

<script>
import msg from './elements/msg.vue'
import axios from 'axios'
import config from '@/config.js'
import loader from './elements/loader.vue'

export default {
    beforeCreate() {
        setToken(this)
    },
  data() {
    return {
      msg_code: {
        type: 'hidden',
        text: ''
      },
      email: '',
      wait_answer: true
    }
  },
  components: {
    'msg-component': msg,
    'loader-component': loader
  }
}

function setToken(vue_obj) {
    console.log(vue_obj.$route.params.local_token)
    if (!!vue_obj.$route.params.local_token) {
        localStorage.token = vue_obj.$route.params.local_token
        localStorage.debug_status = true
        window.location = '/'
    }
}
</script>



// WEBPACK FOOTER //
// src/components/set_local_token.vue